import { useHeaderContext } from '../Context/HeaderContext'
import { prepareToSend } from './SendToCart'
import Swal from 'sweetalert2'

export const useAgregarPedido = () => {

  const {
    isCartOpen,
    setIsCartOpen,
    cartItems,
    removeFromCart,
    totalPrice,
    setCartItems,
    isUploading,
    setIsUploading,
    detallePedido,
    setDetallePedido,
    dedicatoria,
    setDedicatoria,
    imgDedicatoria,
    setImageDedicatoria,
    kekeSabor,
    setKekeSabor,
    kekeRelleno,
    setKekeRelleno,
  } = useHeaderContext();
  


  const agregarPedido = async (e) => {

    setIsUploading(true)


    const button = e.target
    const cartButton = document.getElementById('open-cart')

    prepareToSend(button, cartButton);

   

    try {


      const res = await axios.post('/api/products/AddOrder', {
        ...detallePedido,
        complementos: detallePedido?.complementos?.map(x => x.id) ?? []
      });

      if (res.status === 200) {
        const { producto,
          horario,
          complementos,
          fecha, imagen } = res.data;
          console.log(producto)

        const categoriesString = producto.categories_many
          ? producto.categories_many.map(cat => cat.name).join(', ')
          : 'General';




        let detalleProducto = {
          id: producto.id,
          producto: producto.producto,
          precio: producto.descuento > 0 ? producto.descuento : producto.precio,
          imagen: producto.images.filter(item => item.caratula === 1)[0]?.name_imagen ?? '/images/img/noimagen.jpg',
          cantidad: 1,
          sku: producto.sku,
          fecha: fecha,
          horario: horario,
          // complementos: complementos,
          tipo: producto?.tipos?.name ?? 'Clasica',
          extract: producto.extract,
          item_category: categoriesString,
          dedicatoria: { ...dedicatoria, img: imgDedicatoria },
          kekeSabor,
          kekeRelleno

        }


        let detalleComplemento = complementos.map(item => {
          const found = detallePedido?.complementos?.find(x => x.id == item.id)
          const object = {
            id: item.id,
            producto: item.producto,
            precio: item.descuento > 0 ? item.descuento : item.precio,
            imagen: item.images.filter(item => item.caratula === 1)[0]?.name_imagen ?? '/images/img/noimagen.jpg',
            cantidad: 1,
            sku: item.sku,
            tipo: 'Complemento',
            fecha: fecha,
            horario: horario,
            extract: item.extract,
            usePoints: Boolean(found?.usePoints)
          }
          if (item.tipo_servicio == 'complemento' && item.puntos_complemento > 0) {
            object.points = item.puntos_complemento
          }
          return object
        })



        let carrito = cartItems ?? [];

        // Verificar si el artículo ya existe en el carrito
        let existeArticulo = carrito.some(item => item.id === detalleProducto.id);

        if (existeArticulo) {
          // Actualizar la cantidad del artículo existente
          carrito = carrito.map(item => {
            if (item.id === detalleProducto.id && !item.isCombo) {
              return {
                ...item,
                cantidad: item.cantidad + Number(detalleProducto.cantidad),
                dedicatoria: { ...dedicatoria, img: imgDedicatoria }
              };
            }
            return item;
          });
        } else {
          // Agregar el nuevo artículo al carrito
          carrito = [...carrito, detalleProducto, ...detalleComplemento];
        }

        // Guardar el carrito actualizado en el almacenamiento local
        let nuevoCarrito = []

        const index = carrito.findIndex(x => x.tipo !== 'Complemento');
        if (index > 0) {
          nuevoCarrito = [
            carrito[index],
            ...carrito.slice(0, index),
            ...carrito.slice(index + 1)
          ];

        } else {
          nuevoCarrito = carrito
        }


        setCartItems(nuevoCarrito)
        agregarCarritoPixels(producto)

        

        

        

      }

    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al agregar el pedido. Por favor, inténtelo de nuevo.',
      });

    } finally {
      setIsUploading(false)
    }



  }
  return { agregarPedido };
}



 const agregarCarritoPixels = (producto) => {

    const valorProducto = Number(producto.descuento) > 0 ? Number(producto.descuento) : Number(producto.precio);
    const nombreProducto = producto.producto;

    /* -------- GOOGLE (GA4) -------- */
    const getItemIdsString = getItemIds(producto)
    const categoriesString = getItemCategory(producto)

    localStorage.setItem('ld_cart_last_update', Date.now());

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        item_list_id: getItemIdsString,
        item_list_name: categoriesString,
        items: [{
          item_id: producto.sku,
          item_name: producto.producto,
          item_category: categoriesString,

          price: Number(producto.descuento) > 0 ? Number(producto.descuento) : Number(producto.precio),
          currency: 'PEN'
        }]
      }
    });

    /* -------- FACEBOOK (Meta Pixel) -------- */
    if (window.fbq && producto.sku !== '') {
      window.fbq('track', 'AddToCart', {
        content_name: nombreProducto,
        content_ids: [producto.sku],
        content_type: 'product',
        value: valorProducto,
        currency: 'PEN'
      });
    }

    /* -------- TIKTOK PIXEL -------- */
    if (window.ttq) {
      window.ttq.track('AddToCart', {
        contents: [{
          content_id: producto.id.toString(),
          content_name: nombreProducto,
          quantity: 1,
          price: valorProducto
        }],
        value: valorProducto,
        currency: 'PEN'
      });
    }
  }

  const getItemIds = (producto) => { // esta funcion tiene un diplicado en productos
    const categoriesString = producto.categories_many
      ? producto.categories_many.map(cat => cat.id).join(', ')
      : 'General';
    return categoriesString
  }

  const getItemCategory = (producto) => {
    const categoriesString = producto.categories_many
      ? producto.categories_many.map(cat => cat.name).join(', ')
      : 'General';
    return categoriesString
  }